<div class="container-fluid h-100">
    <div class="row justify-content-center align-items-center">
        <mat-form-field class="col col-md-6">
            <input matInput i18n-placeholder placeholder="Sélectionner un utilisateur" [(ngModel)]="SearchedString" type="text" aria-label="Number" (keyup)="onKeyUp()">
        </mat-form-field>
        <button appPreventDoubleClick class="col-auto ms-1 white" color="accent" mat-raised-button (throttledClick)="openCreationBox()" i18n>
            Nouvel utilisateur
            <mat-icon class="material-symbols-outlined">add</mat-icon>
        </button>
    </div>
    <div class="row">
        <div class="col-12 col-md-3">
            @for (u of UserList; track u) {
            <div class="mt-2 border rounded-1" (click)="SelectedUser = u"
                 [ngStyle]="{'background-color': SelectedUser === u ? 'lightblue': 'white' }">
                <app-avatar [FirstName]="u.FirstName" [LastName]="u.LastName" [IsBold]="u.Type === EUserType.Gestionnaire"></app-avatar>
            </div>
            }
        </div>
        <div class="col-12 col-md-9">
            @if (SelectedUser) {}
            <div class="row justify-content-center m-1">
                @if (SelectedUser) {
                <div class="card my-3 p-0">

                    <h5 class="card-header" i18n> Informations utilisateur</h5>

                    <div class="card-body">
                        <div class="row">
                            <p class="col-6 card-text text-end fst-italic" i18n>Email</p>
                            <span class="col row">
                                <p class="col card-text text-start">{{SelectedUser.Email}}</p>
                            </span>
                        </div>
                        <div class="row">
                            <p class="col card-text text-end fst-italic" i18n>Prénom</p>
                            <p class="col card-text text-start">{{SelectedUser.FirstName}}</p>
                        </div>
                        <div class="row">
                            <p class="col card-text text-end fst-italic" i18n>Nom</p>
                            <p class="col card-text text-start">{{SelectedUser.LastName}}</p>
                        </div>

                        <div class="row">
                            <p class="col card-text text-end fst-italic" i18n>Profil Utilisateur</p>
                            <p class="col card-text text-start">{{getUserTypeLabel()}}</p>
                        </div>

                        <div class="row">
                            <p class="col card-text text-end fst-italic" i18n>Actif</p>
                            <p class="col card-text text-start">{{getUserIsActive()}}</p>
                        </div>

                        <div class="row d-flex justify-content-end no-gutters">

                            <button appPreventDoubleClick mat-mini-fab class="mx-2" color="accent"
                                    (throttledClick)="openCreationBox(SelectedUser)">
                                <mat-icon class="material-symbols-outlined">edit</mat-icon>
                            </button>

                            <button appPreventDoubleClick mat-mini-fab class="mx-2" color="warn" (throttledClick)="deleteUser()">
                                <mat-icon class="material-symbols-outlined">delete</mat-icon>
                            </button>
                        </div>
                    </div>

                </div>
            }
            </div>
            @if (SelectedUser) {}
            <div class="row justify-content-center m-1">
                <div class="card my-3 p-0 ">
                    <h5 class="card-header" i18n> Configuration utilisateur</h5>
                    <div class="row justify-content-center p-2 mt-2">
                        <mat-list class="padding-0-px">
                            @for (c of SelectedUser?.ClientList; track c.Code) {
                            <ng-container>
                                <mat-list-item class="height-auto">
                                    <mat-icon class="col-auto me-3 material-symbols-outlined">face</mat-icon>
                                    {{c.Name}} - {{c.City}} ({{c.ElimsClientCode}})
                                    <!-- {{c.Code}} - {{c.Name}} -->
                                    <mat-icon class="col-auto clickable hidden-element mx-2 material-symbols-outlined"
                                              (click)="deleteClient(c)">delete_outline</mat-icon>
                                </mat-list-item>
                            </ng-container>
                            }
                        </mat-list>
                        <div class="col-auto">
                            <button appPreventDoubleClick mat-raised-button color="primary" (throttledClick)="openClientSelectionBoxForNewClient()" [disabled]="" i18n>
                                Nouveau Client
                                <mat-icon class="material-symbols-outlined">add</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>